import { render, staticRenderFns } from "./SearchResultViewImage.vue?vue&type=template&id=37a35766"
import script from "./SearchResultViewImage.vue?vue&type=script&lang=js"
export * from "./SearchResultViewImage.vue?vue&type=script&lang=js"
import style0 from "./SearchResultViewImage.vue?vue&type=style&index=0&id=37a35766&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports